module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAP0lEQVQY02NgQAOZBcW5WfmFOQyEQHZ+cWNmfmEdHRSC3VRQ1ADDmXmFB4AK96GIAdUQr3AAPYOpsCgPW4ADAP4+QPCYhdDVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/plus_1x.png
// module id = 2316
// module chunks = 0